const DataTypeMap = {
    'invoice': 0,
    'workOrder': 1,
    'quote': 2
}

const dataTypeFromCode = (code) => {
    return Object.keys(DataTypeMap).find((key) => DataTypeMap[key] === code);
}

export { DataTypeMap, dataTypeFromCode };